const route = [
  {
    path: '/booking',
    name: 'booking',
    redirect: '/booking/address',
    component: () => import('@/views/booking/index.vue'),
    children: [
      {
        path: 'address',
        name: 'booking-address',
        component: () => import('@/views/booking/address.vue'),
      },
      {
        path: 'menu/:storeId',
        name: 'booking-menu',
        component: () => import('@/views/booking/menu.vue'),
      },
      {
        path: '/order/:storeId',
        name: 'booking-order',
        component: () => import('@/views/booking/order.vue'),
      },
      {
        path: '/paying/:orderId',
        name: 'paying',
        component: () => import('@/views/booking/pay.vue'),
      },
    ],
  },
];

export default route;
